import { store } from "../redux/store.js";
import { addNotification } from "../redux/slices/admin/notificationSlice.js";
 
export function startSignalR() {
  console.log("Demo SignalR started");
 
  setTimeout(() => {
    store.dispatch(addNotification({
      title: "TestUser: Salam!",
      time: "indi"
    }));
  }, 3000);
}
